import { ApiResultVoElectionMetaResponseVo } from '@schemas/non-auth'
import { useQuery } from '@tanstack/react-query'
import { fetchAPI } from '@utils/http/apiRequest'

interface ElectionMetaReqModel {
	articleIdx?: string
	articleAccessPathCode?: string
	articleAccessIdx?: string
}

const path = '/restapi/v1/get/election/meta'
const queryKeyString = ['@election/meta'] as const

export const queryElectionMeta = async (
	props: ElectionMetaReqModel = {},
	cookieHeader?: string,
): Promise<ApiResultVoElectionMetaResponseVo> => {
	const { articleIdx, articleAccessPathCode, articleAccessIdx } = props
	const params = new URLSearchParams({
		...(articleIdx ? { articleIdx: String(articleIdx) } : {}),
		...(articleAccessPathCode ? { articleAccessPathCode: String(articleAccessPathCode) } : {}),
		...(articleAccessIdx ? { articleAccessIdx: String(articleAccessIdx) } : {}),
	})
	return fetchAPI({ path, params, cookieHeader })
}

export const useElectionMeta = (props: ElectionMetaReqModel, enabled?: boolean) => {
	return useQuery({
		queryKey: [...queryKeyString],
		queryFn: () => queryElectionMeta(props),
		enabled, // 초기 데이터 조회 비활성화 처리
		staleTime: Infinity, // 쿼리가 항상 fresh 상태로 유지
		gcTime: 0, // 필요하다면 캐시도 바로 삭제
		/** 대선 종료로 인한 주기적 리패치 제거 */
		// refetchInterval: 1000 * 60 * (process.env.NEXT_PUBLIC_SITE_MODE === 'production' ? 5 : 2),
	})
}
